import React, { useEffect, useState, useCallback } from 'react';
import PaymentsTable from './PaymentsTable';
import PaymentsTableTopBar from './PaymentsTableTopBar';
import { fetchAllPayments } from '../PaymentsAPI';


const PaymentsContainer = () => {
    const [payments, setPayments] = useState([]);
    const [error, setError] = useState('');
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [filterOptions, setFilterOptions] = useState({});
    const [fetchTrigger, setFetchTrigger] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    const refetchPaymentsData = useCallback(async () => {
        setDataLoaded(false);
        try {
            const data = await fetchAllPayments(pageNumber, 10, filterOptions);
            setPayments(data.payments);
            setTotalPages(data.totalPages || 1);
            setError('');
            setDataLoaded(true);
        } catch (error) {
            console.error('Error fetching all Payments:', error.message);
            setError('Failed to fetch Payments data.');
            setPayments([]);
            setTotalPages(0);
        }
    }, [pageNumber, JSON.stringify(filterOptions)]);

    useEffect(() => {
        refetchPaymentsData();
    }, [pageNumber, fetchTrigger, refetchPaymentsData]);

    return (
        <>
            <PaymentsTableTopBar
                refetchPaymentsReportData={refetchPaymentsData}
                setPageNumber={setPageNumber}
                setFilterOptions={setFilterOptions}
                setFetchTrigger={setFetchTrigger}
            />
            <PaymentsTable
                payments={payments}
                setPayments={setPayments}
                refetchPaymentsReportData={refetchPaymentsData}
                error={error}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                totalPages={totalPages}
                setTotalPages={setTotalPages}
                filterOptions={filterOptions}
                dataLoaded={dataLoaded}
            />
        </>
    );
};


export default PaymentsContainer;
